import { mapState } from 'vuex';
import { generatePredictions, getPrediction, getPredictionEstimate } from '@/api/ai-tools.js';
import aiModelsChainingMixin from '@/components/mixins/ai-models-chaining.mixin.js';

export default {
  name: 'PredictionMixin',
  mixins: [aiModelsChainingMixin],
  data() {
    return {
      outputFiles: null,
      isLoading: false,
      isPredictionLoading: false,
      isPredictionCanceled: false,
      predictionId: null,
      error: null,
      //
      showFadingOutPreview: false,
      //
      interval: null,
      //
      gettingPrediction: false,
      // price estimation
      price: false,
      isPriceLoading: false,
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
      isProgress: state => state.leave.isProgress,
    }),
    isSamePrediction() {
      return this.form.image && _.isEqual(this.form, this.prediction);
    },
    predictionPayload() {
      switch (this.form.model) {
        case 'music_duration':
          return {
            model: this.form.model,
            audio: this.form.audio,
            input: {
              filename: this.form.audio.split('/').pop(),
              url: this.form.audio || this.form.image,
              duration: this.form.fileDuration,
            },
            output: {
              duration: this.form.duration,
            },
          };
        default:
          return this.form;
      }
    },
  },
  mounted() {
    const predictionId = this.$route.query.prediction_id;
    if (predictionId && this.isLoggedIn) {
      this.clearForm();
      this.predictionId = predictionId;
      this.getPrediction();
    }
  },
  beforeDestroy() {
    this.clearInterval();
  },
  watch: {
    isPredictionLoading(isLoading) {
      this.$store.dispatch('leave/setIsProgress', isLoading);
    },
    isProgress(value) {
      console.log('leave/setIsProgress', value);
    },
    'form.image'(value) {
      if (value) {
        this.error = null;
        this.demoImage = null;
        this.showFadingOutPreview = false;
      }
    },
    '$route.query.prediction_id'(value, oldValue) {
      if (value && (value !== oldValue) && oldValue) {
        console.log('================= WATCH $route.query.prediction_id ', value, oldValue);
        this.clearForm();
        this.predictionId = value;
        // this.getPrediction();
      }
    },
  },
  methods: {
    generatePredictions() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;

      if (!this.$v.form.$invalid) {
        this.isLoading = true;
        this.$store.dispatch('leave/setIsProgress', true);
        this.outputFiles = null;
        this.isPredictionCanceled = false;

        generatePredictions(this.predictionPayload)
          .then(response => {
            console.log(response.data);
            const prediction = response.data.data;
            this.$store.dispatch('leave/setIsProgress', false);
            this.predictionId = prediction.id;
            const query = this.clearInputQueryParams(_.clone(this.$route.query));
            this.$router.replace({ query: { ...query, prediction_id: prediction.id } });
            this.isLoading = false;
            this.$store.dispatch('user/setCoins');
            this.pollPrediction();
          })
          .catch((error) => {
            console.error(error);
            this.error = _.get(error, 'response.data.errors[0].detail');
            this.isLoading = false;
            this.$store.dispatch('user/setCoins');
            this.$store.dispatch('leave/setIsProgress', false);
          });
      }
    },
    pollPrediction() {
      this.getPrediction()
        .then((status) => {
          console.log(status);
          if (status && !['succeeded', 'failed'].includes(status)) {
            this.interval = setInterval(() => {
              console.log(this.gettingPrediction);
              if (!this.gettingPrediction) this.getPrediction();
            }, 3000);
          }
        });
    },
    clearInterval() {
      console.log('========== clearInterval ');
      clearInterval(this.interval);
    },
    getPrediction() {
      this.outputFiles = null;
      this.isPredictionLoading = true;
      this.gettingPrediction = true;
      return getPrediction(this.predictionId)
        .then(response => {
          this.gettingPrediction = false;
          const data = response.data.data;
          console.log(data);
          if (this.form.model && this.form.model !== _.get(data, 'model')) {
            this.clearQuery();
            this.isPredictionLoading = false;
            this.clearInterval();
            return;
          }
          if (_.get(data, 'input')) {
            this.setFormFromResponse(data);
          }
          if (this.isPredictionCanceled) {
            this.isPredictionLoading = false;
            this.clearInterval();
          } else if (data.status === 'succeeded') {
            this.showFadingOutPreview = true;
            this.isPredictionLoading = false;
            this.clearInterval();
            this.outputFiles = _.get(data, 'output.files', null);
            this.$store.dispatch('user/setCoins');
          } else if (data.status === 'failed') {
            this.isPredictionLoading = false;
            this.clearInterval();
            this.error = _.get(data, 'prediction.error', true);
            this.$store.dispatch('user/setCoins');
          } else if (!this.isPredictionCanceled) {
            return data.status;
          }
        })
        .catch((error) => {
          this.isPredictionLoading = false;
          this.gettingPrediction = false;
          clearInterval(this.interval);
          this.$store.dispatch('user/setCoins');
          this.error = error;
          console.error(error);
        });
    },
    /*
    cancelPrediction() {
      cancelPrediction(this.predictionId)
        .then(response => {
          console.log(response);
          this.clearQuery();
          this.isPredictionCanceled = true;
          this.isPredictionLoading = false;
        })
        .catch(() => {})
        .finally(() => {
          this.isPredictionLoading = false;
        });
    },
     */
    clearQuery() {
      if (this.$route.query.prediction_id) {
        this.$router.replace({ query: { ...this.$route.query, prediction_id: undefined } });
      }
      if (this.$route.query.intended_url) {
        this.$router.replace({ query: { ...this.$route.query, intended_url: undefined } });
      }
    },
    clearOldPrediction() {
      this.outputFiles = null;
      this.predictionId = null;
      this.error = null;
      this.clearQuery();
    },
    clearPrediction() {
      if (document.querySelector('input[type=file]')) {
        document.querySelector('input[type=file]').value = null;
      }
      this.outputFiles = null;
      this.isLoading = false;
      this.isPredictionLoading = false;
      this.predictionId = null;
      this.error = null;
      this.$v.form.$reset();
      this.clearForm();
      this.clearQuery();
    },
    //
    getPredictionEstimate(params) {
      this.isPriceLoading = true;
      getPredictionEstimate({
        model: this.form.model,
        ...params,
      })
        .then(response => {
          console.log(response.data);
          this.price = response.data.data.coins;
          this.isPriceLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$v.form.$touch();
          this.isPriceLoading = false;
        });
    },
    clearInputQueryParams(query) {
      query = Object.fromEntries(Object.entries(query).filter(([key]) => !(key.includes('input_') || key.includes('X-Amz'))));
      return query;
    },
    handleSourceImageChange() {
      const query = this.clearInputQueryParams(_.clone(this.$route.query));
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
